"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "ContextProvider", {
  enumerable: true,
  get: function get() {
    return _Context.ContextProvider;
  }
});

_Object$defineProperty(exports, "ContextConsumer", {
  enumerable: true,
  get: function get() {
    return _Context.ContextConsumer;
  }
});

_Object$defineProperty(exports, "AccountDropdown", {
  enumerable: true,
  get: function get() {
    return _AccountDropdown["default"];
  }
});

_Object$defineProperty(exports, "AccountMenuItem", {
  enumerable: true,
  get: function get() {
    return _AccountMenuItem["default"];
  }
});

_Object$defineProperty(exports, "Avatar", {
  enumerable: true,
  get: function get() {
    return _Avatar["default"];
  }
});

_Object$defineProperty(exports, "Content", {
  enumerable: true,
  get: function get() {
    return _Content["default"];
  }
});

_Object$defineProperty(exports, "HeaderNav", {
  enumerable: true,
  get: function get() {
    return _HeaderNav["default"];
  }
});

_Object$defineProperty(exports, "Logo", {
  enumerable: true,
  get: function get() {
    return _Logo["default"];
  }
});

_Object$defineProperty(exports, "NavDropdown", {
  enumerable: true,
  get: function get() {
    return _NavDropdown["default"];
  }
});

_Object$defineProperty(exports, "NavMenuButton", {
  enumerable: true,
  get: function get() {
    return _NavMenuButton["default"];
  }
});

_Object$defineProperty(exports, "NavMenuDivider", {
  enumerable: true,
  get: function get() {
    return _NavMenuDivider["default"];
  }
});

_Object$defineProperty(exports, "NavMenuHeading", {
  enumerable: true,
  get: function get() {
    return _NavMenuHeading["default"];
  }
});

_Object$defineProperty(exports, "NavMenuItem", {
  enumerable: true,
  get: function get() {
    return _NavMenuItem["default"];
  }
});

_Object$defineProperty(exports, "NavSearch", {
  enumerable: true,
  get: function get() {
    return _NavSearch["default"];
  }
});

_Object$defineProperty(exports, "Nav", {
  enumerable: true,
  get: function get() {
    return _Nav["default"];
  }
});

_Object$defineProperty(exports, "AppSwitcher", {
  enumerable: true,
  get: function get() {
    return _AppSwitcher["default"];
  }
});

_Object$defineProperty(exports, "Banner", {
  enumerable: true,
  get: function get() {
    return _Banner["default"];
  }
});

_Object$defineProperty(exports, "Section", {
  enumerable: true,
  get: function get() {
    return _Section["default"];
  }
});

exports["default"] = exports.CommonChrome = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Context = require("./components/Context");

var _AccountDropdown = _interopRequireDefault(require("./components/AccountDropdown"));

var _AccountMenuItem = _interopRequireDefault(require("./components/AccountMenuItem"));

var _Avatar = _interopRequireDefault(require("./components/Avatar"));

var _Content = _interopRequireDefault(require("./components/Content"));

var _HeaderNav = _interopRequireDefault(require("./components/HeaderNav"));

var _Logo = _interopRequireDefault(require("./components/Logo"));

var _NavDropdown = _interopRequireDefault(require("./components/NavDropdown"));

var _NavMenuButton = _interopRequireDefault(require("./components/NavMenuButton"));

var _NavMenuDivider = _interopRequireDefault(require("./components/NavMenuDivider"));

var _NavMenuHeading = _interopRequireDefault(require("./components/NavMenuHeading"));

var _NavMenuItem = _interopRequireDefault(require("./components/NavMenuItem"));

var _NavSearch = _interopRequireDefault(require("./components/NavSearch"));

var _Nav = _interopRequireDefault(require("./components/Nav"));

var _AppSwitcher = _interopRequireDefault(require("./components/AppSwitcher/AppSwitcher"));

var _Banner = _interopRequireDefault(require("./components/Banner"));

var _Section = _interopRequireDefault(require("./components/Section"));

var _BasicUserContextProvider = require("./components/UserContext/BasicUserContextProvider");

var _SupportDropdown = require("./components/SupportDropdown");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var CommonChrome = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(CommonChrome, _React$Component);

  var _super = _createSuper(CommonChrome);

  function CommonChrome() {
    (0, _classCallCheck2["default"])(this, CommonChrome);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(CommonChrome, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          activeKey = _this$props.activeKey,
          children = _this$props.children,
          chromeless = _this$props.chromeless,
          className = _this$props.className,
          _this$props$hasSideba = _this$props.hasSidebar,
          hasSidebar = _this$props$hasSideba === void 0 ? true : _this$props$hasSideba,
          links = _this$props.links,
          LinkWrapper = _this$props.LinkWrapper,
          banner = _this$props.banner,
          _this$props$UserConte = _this$props.UserContextProvider,
          UserContextProvider = _this$props$UserConte === void 0 ? _BasicUserContextProvider.BasicUserContextProvider : _this$props$UserConte;
      var hasLinks = this.props.hasLinks || (links || []).length > 0;
      return /*#__PURE__*/_react["default"].createElement(UserContextProvider, null, /*#__PURE__*/_react["default"].createElement(_Context.ContextProvider, {
        activeKey: activeKey,
        banner: banner,
        chromeless: chromeless,
        hasSidebar: hasSidebar,
        links: links,
        hasLinks: hasLinks,
        LinkWrapper: LinkWrapper
      }, /*#__PURE__*/_react["default"].createElement(_Context.ContextConsumer, null, function (_ref) {
        var chromelessFloating = _ref.chromelessFloating,
            expanded = _ref.expanded,
            banner = _ref.banner;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: (0, _classnames["default"])('cloud-ui-nav-root', className, {
            chromeless: chromeless,
            floating: chromelessFloating,
            expanded: expanded,
            'with-banner': banner,
            'without-sidebar': !hasSidebar,
            'without-links': !hasLinks
          })
        }, children);
      })));
    }
  }]);
  return CommonChrome;
}(_react["default"].Component);

exports.CommonChrome = CommonChrome;
(0, _defineProperty2["default"])(CommonChrome, "AccountDropdown", _AccountDropdown["default"]);
(0, _defineProperty2["default"])(CommonChrome, "AccountMenuItem", _AccountMenuItem["default"]);
(0, _defineProperty2["default"])(CommonChrome, "AppSwitcher", _AppSwitcher["default"]);
(0, _defineProperty2["default"])(CommonChrome, "Avatar", _Avatar["default"]);
(0, _defineProperty2["default"])(CommonChrome, "Content", _Content["default"]);
(0, _defineProperty2["default"])(CommonChrome, "HeaderNav", _HeaderNav["default"]);
(0, _defineProperty2["default"])(CommonChrome, "Logo", _Logo["default"]);
(0, _defineProperty2["default"])(CommonChrome, "Nav", _Nav["default"]);
(0, _defineProperty2["default"])(CommonChrome, "NavDropdown", _NavDropdown["default"]);
(0, _defineProperty2["default"])(CommonChrome, "NavMenuButton", _NavMenuButton["default"]);
(0, _defineProperty2["default"])(CommonChrome, "NavMenuDivider", _NavMenuDivider["default"]);
(0, _defineProperty2["default"])(CommonChrome, "NavMenuHeading", _NavMenuHeading["default"]);
(0, _defineProperty2["default"])(CommonChrome, "NavMenuItem", _NavMenuItem["default"]);
(0, _defineProperty2["default"])(CommonChrome, "NavSearch", _NavSearch["default"]);
(0, _defineProperty2["default"])(CommonChrome, "Context", _Context.Context);
(0, _defineProperty2["default"])(CommonChrome, "ContextConsumer", _Context.ContextConsumer);
(0, _defineProperty2["default"])(CommonChrome, "ContextProvider", _Context.ContextProvider);
(0, _defineProperty2["default"])(CommonChrome, "Banner", _Banner["default"]);
(0, _defineProperty2["default"])(CommonChrome, "Section", _Section["default"]);
(0, _defineProperty2["default"])(CommonChrome, "SupportDropdown", _SupportDropdown.SupportDropdown);
var _default = CommonChrome;
exports["default"] = _default;